import { createAction, props } from '@ngrx/store';

import { ApiStatus } from '@amfam/shared/models';

import { ChangeRequest, PolicyAnalyticActionPayload } from '../models';

export enum PolicyChangeActionTypes {
  // Actions to change the policy information
  POLICY_CHANGE_REQUEST_NOTIFICATION = '[Policy_Change] Start Notification',
  POLICY_CHANGE_SUCCESS_NOTIFICATION = '[Policy_Change] Success Notification',
  POLICY_CHANGE_FAIL_NOTIFICATION = '[Policy_Change] Fail NOtification',

  POLICY_CHANGE_REQUEST_EMAIL_NOTIFICATION = '[Policy_Change] Start Email Notification',
  POLICY_CHANGE_SUCCESS_EMAIL_NOTIFICATION = '[Policy_Change] Success Email Notification',
  POLICY_CHANGE_FAIL_EMAIL_NOTIFICATION = '[Policy_Change] Fail Email Notification',

  POLICY_CHANGE_REQUEST_ANS_NOTIFICATION = '[Policy_Change] Start ANS Notification',
  POLICY_CHANGE_SUCCESS_ANS_NOTIFICATION = '[Policy_Change] Success ANS Notification',
  POLICY_CHANGE_FAIL_ANS_NOTIFICATION = '[Policy_Change] Fail ANS Notification',

  POLICY_CHANGE_REQUEST_ANALYTIC_INFORMATION = '[Policy_Change] Send Analytic Information',

  POLICY_CHANGE_REQUEST_RESET_STATE = '[Policy_Change] Reset State',
  POLICY_CHANGE_REQUEST_SET_CANCEL_PATH = '[Policy_Change] Set Cancel Path'
}

// export class PolicyChangeRequestNotificationAction implements Action {
//   readonly type = PolicyChangeActionTypes.POLICY_CHANGE_REQUEST_NOTIFICATION;
//   constructor(public payload: ChangeRequest) {}
// }

export const PolicyChangeRequestNotificationAction = createAction(
  PolicyChangeActionTypes.POLICY_CHANGE_REQUEST_NOTIFICATION,
  props<{ payload: ChangeRequest }>()
);

// export class PolicyChangeRequestNotificationSuccessAction implements Action {
//   readonly type = PolicyChangeActionTypes.POLICY_CHANGE_SUCCESS_NOTIFICATION;
//   constructor(public payload: ChangeRequest) {}
// }

export const PolicyChangeRequestNotificationSuccessAction = createAction(
  PolicyChangeActionTypes.POLICY_CHANGE_SUCCESS_NOTIFICATION,
  props<{ payload: ChangeRequest }>()
);

// export class PolicyChangeRequestNotificationFailAction implements Action {
//   readonly type = PolicyChangeActionTypes.POLICY_CHANGE_FAIL_NOTIFICATION;
//   constructor(public payload: ApiStatus) {}
// }

export const PolicyChangeRequestNotificationFailAction = createAction(
  PolicyChangeActionTypes.POLICY_CHANGE_FAIL_NOTIFICATION,
  props<{ payload: ApiStatus }>()
);

// export class PolicyChangeRequestEmailNotificationAction implements Action {
//   readonly type = PolicyChangeActionTypes.POLICY_CHANGE_REQUEST_EMAIL_NOTIFICATION;
//   constructor(public payload: ChangeRequest) {}
// }

export const PolicyChangeRequestEmailNotificationAction = createAction(
  PolicyChangeActionTypes.POLICY_CHANGE_REQUEST_EMAIL_NOTIFICATION,
  props<{ payload: ChangeRequest }>()
);

// export class PolicyChangeRequestSuccessEmailNotificationAction implements Action {
//   readonly type = PolicyChangeActionTypes.POLICY_CHANGE_SUCCESS_EMAIL_NOTIFICATION;
//   constructor(public payload: ChangeRequest) {}
// }

export const PolicyChangeRequestSuccessEmailNotificationAction = createAction(
  PolicyChangeActionTypes.POLICY_CHANGE_SUCCESS_EMAIL_NOTIFICATION,
  props<{ payload: ChangeRequest }>()
);

// export class PolicyChangeRequestFailEmailNotificationAction implements Action {
//   readonly type = PolicyChangeActionTypes.POLICY_CHANGE_FAIL_EMAIL_NOTIFICATION;
//   constructor(public payload: ApiStatus) {}
// }

export const PolicyChangeRequestFailEmailNotificationAction = createAction(
  PolicyChangeActionTypes.POLICY_CHANGE_FAIL_EMAIL_NOTIFICATION,
  props<{ payload: ApiStatus }>()
);
// export class PolicyChangeRequestResetStateAction implements Action {
//   readonly type = PolicyChangeActionTypes.POLICY_CHANGE_REQUEST_RESET_STATE;
//   constructor(public payload?: ApiStatus) {}
// }

export const PolicyChangeRequestResetStateAction = createAction(
  PolicyChangeActionTypes.POLICY_CHANGE_REQUEST_RESET_STATE
);

// export class PolicyChangeRequestANSNotificationAction implements Action {
//   readonly type = PolicyChangeActionTypes.POLICY_CHANGE_REQUEST_ANS_NOTIFICATION;
//   constructor(public payload: ChangeRequest) {}
// }

export const PolicyChangeRequestANSNotificationAction = createAction(
  PolicyChangeActionTypes.POLICY_CHANGE_REQUEST_ANS_NOTIFICATION,
  props<{ payload: ChangeRequest }>()
);

// export class PolicyChangeRequestSuccessANSNotificationAction implements Action {
//   readonly type = PolicyChangeActionTypes.POLICY_CHANGE_SUCCESS_ANS_NOTIFICATION;
//   constructor(public payload: ChangeRequest) {}
// }

export const PolicyChangeRequestSuccessANSNotificationAction = createAction(
  PolicyChangeActionTypes.POLICY_CHANGE_SUCCESS_ANS_NOTIFICATION,
  props<{ payload: ChangeRequest }>()
);

// export class PolicyChangeRequestFailANSNotificationAction implements Action {
//   readonly type = PolicyChangeActionTypes.POLICY_CHANGE_FAIL_ANS_NOTIFICATION;
//   constructor(public payload: {}) {}
// }

export const PolicyChangeRequestFailANSNotificationAction = createAction(
  PolicyChangeActionTypes.POLICY_CHANGE_FAIL_ANS_NOTIFICATION,
  props<{ payload: ApiStatus }>()
);

// export class PolicyChangeRequestSendAnalyticAction implements Action {
//   readonly type = PolicyChangeActionTypes.POLICY_CHANGE_REQUEST_ANALYTIC_INFORMATION;
//   constructor(public payload: PolicyAnalyticActionPayload) {}
// }

export const PolicyChangeRequestSendAnalyticAction = createAction(
  PolicyChangeActionTypes.POLICY_CHANGE_REQUEST_ANALYTIC_INFORMATION,
  props<{ payload: PolicyAnalyticActionPayload }>()
);

// export class PolicyChangeRequestSetCancelPathAction implements Action {
//   readonly type = PolicyChangeActionTypes.POLICY_CHANGE_REQUEST_SET_CANCEL_PATH;
//   constructor(public payload: string) {}
// }

export const PolicyChangeRequestSetCancelPathAction = createAction(
  PolicyChangeActionTypes.POLICY_CHANGE_REQUEST_SET_CANCEL_PATH,
  props<{ payload: string }>()
);

export const addressChangeNotification = createAction(
  '[Address Change] Notification',
  props<{ payload: ChangeRequest }>()
);

export const addressChangeNotificationSuccess = createAction(
  '[Address Change] Notification Success',
  props<{ payload: ChangeRequest }>()
);

export const addressChangeNotificationFailed = createAction(
  '[Address Change] Notification Failed',
  props<{ payload: ApiStatus }>()
);

export const addressChangeAgentEmail = createAction(
  '[Address Change] Agent Email',
  props<{ payload: ChangeRequest }>()
);

export const addressChangeAgentEmailSuccess = createAction(
  '[Address Change] Agent Email Success',
  props<{ payload: ChangeRequest }>()
);

export const addressChangeAgentEmailFailed = createAction(
  '[Address Change] Agent Email Failed',
  props<{ payload: ChangeRequest; status: ApiStatus }>()
);

export const addressChangeANS = createAction(
  '[Address Change] ANS',
  props<{ payload: ChangeRequest }>()
);

export const addressChangeANSSuccess = createAction(
  '[Address Change] ANS Success',
  props<{ payload: ChangeRequest }>()
);

export const addressChangeANSFailed = createAction(
  '[Address Change] ANS Failed',
  props<{ payload: ChangeRequest; status: ApiStatus }>()
);

export const addressChangeCustomerEmail = createAction(
  '[Address Change] Customer Email',
  props<{ payload: ChangeRequest }>()
);

export const addressChangeCustomerEmailSuccess = createAction(
  '[Address Change] Customer Email',
  props<{ payload: ChangeRequest }>()
);

export const addressChangeCustomerEmailFailed = createAction(
  '[Address Change] Customer Email',
  props<{ payload: ApiStatus }>()
);

export const driverLicenseChangeANS = createAction(
  '[Driver License Change] ANS',
  props<{ payload: ChangeRequest }>()
);

export const driverLicenseChangeANSSuccess = createAction(
  '[Driver License Change] ANS Success',
  props<{ payload: ChangeRequest }>()
);

export const driverLicenseChangeANSFailed = createAction(
  '[Driver License Change] ANS Failed',
  props<{ payload: ApiStatus }>()
);

export const driverLicenseChangeCustomerEmail = createAction(
  '[Driver License Change] Customer Email',
  props<{ payload: ChangeRequest }>()
);

export const driverLicenseChangeCustomerEmailSuccess = createAction(
  '[Driver License Change] Customer Email',
  props<{ payload: ChangeRequest }>()
);

export const driverLicenseChangeCustomerEmailFailed = createAction(
  '[Driver License Change] Customer Email',
  props<{ payload: ApiStatus }>()
);

export const vinChangeNotification = createAction(
  '[Vin Change] Notification',
  props<{ payload: ChangeRequest }>()
);

export const vinChangeNotificationSuccess = createAction(
  '[Vin Change] Notification Success',
  props<{ payload: ChangeRequest }>()
);

export const vinChangeNotificationFailed = createAction(
  '[Vin Change] Notification Failed',
  props<{ payload: ApiStatus }>()
);

export const vinChangeAgentEmail = createAction(
  '[Vin Change] Agent Email',
  props<{ payload: ChangeRequest }>()
);

export const vinChangeAgentEmailSuccess = createAction(
  '[Vin Change] Agent Email Success',
  props<{ payload: ChangeRequest }>()
);

export const vinChangeAgentEmailFailed = createAction(
  '[Vin Change] Agent Email Failed',
  props<{ payload: ChangeRequest; status: ApiStatus }>()
);

export const vinChangeANS = createAction('[Vin Change] ANS', props<{ payload: ChangeRequest }>());

export const vinChangeANSSuccess = createAction(
  '[Vin Change] ANS Success',
  props<{ payload: ChangeRequest }>()
);

export const vinChangeANSFailed = createAction(
  '[Vin Change] ANS Failed',
  props<{ payload: ChangeRequest; status: ApiStatus }>()
);

export const vinChangeCustomerEmail = createAction(
  '[Vin Change] Customer Email',
  props<{ payload: ChangeRequest }>()
);

export const vinChangeCustomerEmailSuccess = createAction(
  '[Vin Change] Customer Email',
  props<{ payload: ChangeRequest }>()
);

export const vinChangeCustomerEmailFailed = createAction(
  '[Vin Change] Customer Email',
  props<{ payload: ApiStatus }>()
);
